import { render, staticRenderFns } from "./LeadCenterSettings.vue?vue&type=template&id=3f5720a1&"
import script from "./LeadCenterSettings.vue?vue&type=script&lang=js&"
export * from "./LeadCenterSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports